import { makeAutoObservable } from 'mobx'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { uiStore } from 'shared/store/uiStore'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { SettingsPath } from 'pages/settings/route/settingsPath'
import { type IGoToQuestionnaireModalType } from './types'

export class GoToQuestionnaireModalStore {
  private _modalId = 'GoToQuestionnaire'
  private _type: IGoToQuestionnaireModalType | null = null

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  get desc() {
    if (this._type === 'numbers') {
      return "Before adding a number, we'll ask a few quick questions to tailor your experience."
    }

    if (this._type === 'inboxes') {
      if (this._entities.complianceStore.isQuestionnaire) {
        return 'Before creating an inbox, pick your phone number to kick off the approval process'
      }

      return "Before creating an inbox, we'll ask a few quick questions to tailor your experience."
    }

    if (this._entities.complianceStore.isQuestionnaire) {
      return 'Before inviting members, pick your phone number to kick off the approval process'
    }

    return "Before inviting members, we'll ask a few quick questions to tailor your experience."
  }

  get title() {
    if (this._entities.complianceStore.isQuestionnaire) {
      return 'Choose your number'
    }

    return 'Let’s personalize your approval process'
  }

  get buttonText() {
    if (this._entities.complianceStore.isQuestionnaire) {
      return 'Choose number'
    }

    return 'Get started'
  }

  onAction = () => {
    if (this._entities.complianceStore.isQuestionnaire) {
      uiStore.changeRouteViaVue({
        path: '/settings/organization/numbers',
      })
      this._entities.numbersStore.initSelectNumberModal()

      return
    }

    uiStore.changeRouteViaVue({
      path: `/${SettingsPath.compliance.questionnaire.root}`,
      name: 'settings.organization.compliance.questionnaire',
      options: {
        state: 'started',
      },
    })
  }

  open = (type: IGoToQuestionnaireModalType) => {
    this._type = type

    if (this._entities.complianceStore.isQuestionnaire && type === 'numbers') {
      this._entities.numbersStore.initSelectNumberModal()
    } else {
      modalStore.addModal({
        id: this._modalId,
        type: ModalTypeList.INFO,
        title: this.title,
        desc: this.desc,
        primaryAction: {
          text: this.buttonText,
          onAction: () => {
            this.onAction()
            modalStore.removeModal(this._modalId)
          },
        },
        secondaryAction: {
          text: 'Cancel',
          onAction: () => {
            modalStore.removeModal(this._modalId)
          },
        },
      })
    }
  }
}
